import { render } from "./Salesman.vue?vue&type=template&id=28069d1a"
import script from "./Salesman.vue?vue&type=script&lang=js"
export * from "./Salesman.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\KIM\\pvmi-coaching-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__